import { Accordion } from 'admin-web-ui'
import React from 'react'
import { Entitlement, HydratedUserInfo } from '../types'
import { DisplayList, SubGroupLabel } from './components'

interface Props extends Pick<HydratedUserInfo, 'entitlements'> {}

export const EntitlementSection: React.FC<Props> = ({ entitlements }) => {
  if (!entitlements?.length) return null

  return (
    <Accordion title="Entitlements">
      <DisplayList>
        {orderedEntitlementGroups.map((group) => (
          <EntitlementSubsection
            key={group.title}
            {...group}
            entitlements={entitlements}
          />
        ))}
      </DisplayList>
    </Accordion>
  )
}

interface SubsectionProps {
  title: string
  matchers: string[]
  entitlements: Entitlement[]
}
const EntitlementSubsection: React.FC<SubsectionProps> = ({
  title,
  matchers,
  entitlements,
}) => {
  const filteredEntitlements = entitlements.filter((e) =>
    matchers.some((matcher) => e.name.includes(matcher)),
  )

  return filteredEntitlements.length ? (
    <>
      <SubGroupLabel>{title}</SubGroupLabel>
      {filteredEntitlements.map((entitlement: Entitlement) => (
        <p key={entitlement.name}>
          {entitlement.description
            ? `${entitlement.description}: ${entitlement.value}`
            : `${entitlement.name}: ${entitlement.value}`}
          <br />
        </p>
      ))}
    </>
  ) : null
}

const orderedEntitlementGroups = [
  {
    title: 'Decentralized Identity',
    matchers: ['sudoplatform.identity-verification'],
  },
  {
    title: 'Email',
    matchers: ['sudoplatform.email'],
  },
  {
    title: 'Email Sanitization',
    matchers: ['sudoplatform.email-sanitization.'],
  },
  {
    title: 'Password Manager',
    matchers: ['sudoplatform.vault.'],
  },
  {
    title: 'Safe Browser',
    matchers: ['sudoplatform.atb.', 'sudoplatform.sr.'],
  },
  {
    title: 'Sudos',
    matchers: ['sudoplatform.sudo.'],
  },
  {
    title: 'Telephony',
    matchers: ['sudoplatform.telephony.'],
  },
  {
    title: 'Virtual Cards',
    matchers: ['sudoplatform.virtual-cards.'],
  },
  {
    title: 'VPN',
    matchers: ['sudoplatform.vpn.'],
  },
]
